export const processCatalogMenu = (data: any, included: any) => {
  let dataMenus = data.menus;
  let includedMenus = included.menus;

  let finalMenu = [];

  for (const menu of includedMenus) {
    const menuId = menu.id;

    let weekDays = dataMenus.filter((obj: any) => {
      return obj.menuId === menuId;
    });

    menu.weekDays = weekDays;
    finalMenu.push(menu);

    // exclude the menuid on next loop
    dataMenus = dataMenus.filter((obj: any) => {
      return obj.menuId !== menuId;
    });
  }
  return finalMenu;
};

export const processDishesMeals = (
  data: any,
  categories?: any,
  rawDish?: boolean
) => {
  let meals = [];

  if (rawDish) {
    meals = data.flatMap((item: any) => {
      const category = categories?.find(
        (cat: any) => cat.categoryId === item.categoryId
      );

      return {
        ...item,
        category: category,
        dishName: item.name,
        name: item.name,
        description: item.description,
        imageUrl: item.imageUrl,
        thumbnailUrl: item.thumbnailUrl,
      };
    });
  } else {
    meals = data.reduce((acc: any, item: any) => {
      const groupedMeals: { [key: string]: any } = {};
      const category = categories?.find(
        (cat: any) => cat.categoryId === item.categoryId
      );

      // group meals by name
      item.meals.forEach((meal: any) => {
        const name = meal.name.trim().toLowerCase();
        if (groupedMeals[name]) {
          groupedMeals[name].portions.push({
            id: meal.mealId,
            portionId: meal.portionId,
          });
        } else {
          groupedMeals[name] = {
            ...item,
            category: category,
            dishName: item.name,
            name: meal.name,
            description: item.description,
            imageUrl: item.imageUrl,
            thumbnailUrl: item.thumbnailUrl,
            portions: [{ id: meal.mealId, portionId: meal.portionId }],
          };
        }
      });

      // add grouped meals to accumulator
      Object.values(groupedMeals).forEach((meal: any) => {
        acc.push(meal);
      });

      return acc;
    }, []);
  }

  // sort by category name
  meals.sort((a: any, b: any) => {
    if (a?.category?.title < b?.category?.title) return -1;
    if (a?.category?.title > b?.category?.title) return 1;
    return 0;
  });

  return meals;
};
